export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14833.7f34f547.jpg";